import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { type AidRequestForm } from "./entity";

export const AidRequestFormEntityConfig: HyperEntityConfig<AidRequestForm> = {
  allowApiRead: true,
  allowApiCrud: Roles.AdminsAndManager,
  apiPrefilterPerRole(filter) {
    if (!remult.user) return;

    filter(Roles.User, true);

    filter(Roles.Manager, {
      team: {
        $id: {
          $in: remult.user.managingTeams,
        },
      },
    });

    filter([Roles.Admin, Roles.SuperAdmin], {
      organization: {
        $id: remult.user.organizationId,
      },
    });

    filter(Roles.SuperDuperAdmin, false);
  },

  allowInsertPerRole(allow) {
    allow(Roles.SuperAdmin, {
      organization: {
        $id: remult.user!.organizationId,
      },
    });

    allow(
      Roles.AdminsAndManager,
      (entity) => entity.organizationId === remult.user!.organizationId,
    );
  },

  allowDeleteAndUpdatePerRole(allow) {
    allow(Roles.SuperAdmin, {
      organization: {
        $id: remult.user!.organizationId,
      },
    });

    allow(
      Roles.AdminsAndManager,
      (entity) => entity.organizationId === remult.user!.organizationId,
    );
  },
};
